module.exports = __webpack_public_path__ + "media/entities/1201-e895cde0.png";